import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ValidatorFn, ValidationErrors } from '@angular/forms';
import { UserActivationService } from 'src/app/shared/services/user-activation.service';
import { NotificationsService } from 'src/app/shared/notifications.service';
import * as uuid from 'uuid';

@Component({
	selector: 'app-activation',
	templateUrl: './activation.component.html',
	styleUrls: ['./activation.component.scss']
})
export class ActivationComponent implements OnInit {

	passwordsForm: UntypedFormGroup
	path: string = this.activatedRoute.snapshot.url[0].path
	emailKey: string = this.activatedRoute.snapshot.params.emailKey
	userId: string = this.activatedRoute.snapshot.params.userId

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private formBuilder: UntypedFormBuilder,
		private activationService: UserActivationService,
		private notificationService: NotificationsService
	) { }

	ngOnInit() {
		if (!this.emailKey && !this.userId) {
			this.router.navigate(['login'])
		} else {
			this.passwordsForm = this.formBuilder.group({
				password: [null, Validators.required],
				confirmPassword: [null, Validators.required]
			}, { validators: comparePasswords })
			const finger = uuid.v4()

			if (this.router.url.includes('ativacao')) {
				this.activationService.validateActivationRequest(this.activatedRoute.snapshot.params.emailKey, finger).toPromise().then(
					res => {
						localStorage.setItem('finger', finger)
					},
					error => {
						if (error.errorCodes[0] == 'validation_failed') {
							this.notificationService.showError('Link inválido', 'Erro')
							this.router.navigate(['login'])
						}
					}
				);
			} else {
				this.activationService.validateResetActivationRequest(this.activatedRoute.snapshot.params.emailKey, finger).toPromise().then(
					res => {
						localStorage.setItem('finger', finger)
					},
					error => {
						if (error.errorCodes[0] == 'validation_failed') {
							this.notificationService.showError('Link inválido', 'Erro')
							this.router.navigate(['login'])
						}
					}
				);
			}


		}
	}

	submitPasswords() {
		switch (this.path) {
			case 'ativacao':
				this.activationService.putPassword(this.userId, this.passwordsForm.get('password').value).toPromise().then(
					res => {
						this.notificationService.showSuccess('Usuário ativado', 'Sucesso')
						this.router.navigate(['login'])
					}, 
					error => {
						console.error(error)
					}
				)
				break;
			case 'recuperacao':
				this.activationService.putPasswordReset(this.userId, this.passwordsForm.get('password').value).toPromise().then(
					res => {
						this.notificationService.showSuccess('Senha foi atualizada', 'Sucesso')
						this.router.navigate(['login'])
					}, 
					error => {
						console.error(error)
					}
				)
				break;
			default:
				break;
		}

	}

}
export const comparePasswords: ValidatorFn = (control: UntypedFormGroup): ValidationErrors | null => {
	const password = control.get('password').value
	const confirmPassword = control.get('confirmPassword').value

	if (password !== confirmPassword) {
		return { 'passwordMismatch': true }
	} else {
		return null
	}

}